const isBrowser = window.document;

const GOOGLE_MAPS_URL =
  "https://maps.googleapis.com/maps/api/js?libraries=places&loading=async";

export const loadGoogleMaps = async (apiKey, language) => {
  if (!isBrowser) {
    return Promise.resolve();
  }

  if (typeof google !== "undefined") {
    // eslint-disable-next-line
    if (google.maps && google.maps.places) {
      return Promise.resolve();
    }
  }

  const scriptElements = document.querySelectorAll(
    'script[src*="'.concat(GOOGLE_MAPS_URL, '"]')
  );

  if (scriptElements && scriptElements.length > 0) {
    return new Promise((resolve) => {
      if (typeof google !== "undefined") {
        return resolve();
      }
      scriptElements[0].addEventListener("load", () => {
        return resolve();
      });
    });
  }

  const scriptUrl = new URL(`${GOOGLE_MAPS_URL}&key=${apiKey}`);
  scriptUrl.searchParams.set("callback", "initService");
  scriptUrl.searchParams.set("language", language);
  const el = document.createElement("script");
  el.id = "google-maps";
  el.src = scriptUrl.toString();
  return new Promise((resolve) => {
    window.initService = resolve;
    document.body.appendChild(el);
  });
};
